<template>
  <svg
    viewBox="0 0.832 499.736 497.771"
    width="499.736"
    height="497.771"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="clip-path">
        <circle class="cls-1" cx="750" cy="500" r="331" style="fill: none" />
      </clipPath>
    </defs>
    <g
      class="cls-2"
      transform="matrix(0.752958, 0, 0, 0.748697, -315.131592, -124.768959)"
      style="clip-path: url(#clip-path)"
    >
      <rect
        class="cls-3"
        x="250.02"
        y="167.15"
        width="999.95"
        height="665.71"
        style="fill: rgb(235, 32, 39)"
      />
      <rect
        class="cls-4"
        x="250.02"
        y="279.71"
        width="999.95"
        height="442.52"
        style="fill: rgb(255, 255, 255)"
      />
      <rect
        class="cls-5"
        x="250.02"
        y="390.34"
        width="999.95"
        height="221.26"
        style="fill: rgb(36, 28, 78)"
      />
    </g>
  </svg>
</template>
